import PropTypes from "prop-types";
import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "examples/Sidenav/styles/sidenavCollapse";
import { useSoftUIController } from "context";
import { useSelector } from "react-redux";

function SidenavCollapse({ color, icon, name, children, active, noCollapse, open, ...rest }) {

  const [controller] = useSoftUIController();
  const { miniSidenav, transparentSidenav, sidenavColor } = controller;
  const userTheme = useSelector((state) => state.commonSlice.theme);

  return (
    <>
      <ListItem component="li">
        <SoftBox variant="gradient"
          className={active ? "glassmorphism-card2" : ''}

          {...rest} sx={(theme) => collapseItem(theme, { active, transparentSidenav })}>

          <SoftBox
            variant="gradient"
            bgColor={active ? sidenavColor : 'white'}
            color={active ? "white" : "black"}
            width="2.2rem"
            height="2.2rem"
            marginLeft="auto"
            borderRadius="md"
            display="flex"
            justifyContent="center"
            alignItems="center"
            shadow="md"
          >
            {icon}
          </SoftBox>

          <ListItemText
          
            primary={name}
            sx={(theme) => ({
              ...collapseText(theme, { miniSidenav, transparentSidenav, active ,userTheme}),
            })}
          />
        </SoftBox>
      </ListItem>
      {children && (
        <Collapse in={open} unmountOnExit>
          {children}
        </Collapse>
      )}
    </>
  );
}

// Setting default values for the props of SidenavCollapse
SidenavCollapse.defaultProps = {
  color: "info",
  active: false,
  noCollapse: false,
  children: false,
  open: false,
};

// Typechecking props for the SidenavCollapse
SidenavCollapse.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
  active: PropTypes.bool,
  noCollapse: PropTypes.bool,
  open: PropTypes.bool,
};

export default SidenavCollapse;
